import { UnikoServiceTypes } from "src/app/services/payments-api.service";
import { availableServices } from "./available-services";

export const photographyService = {
    title: 'photography.title',
    img: '../../../../assets/img/services/property-service-photography.png',
    descPart1: `photography.descriptionPart1`,
    deliveryDays: 5,
    serviceFee: 200,
    contents: {
      topRow: [
        {
          img: '../../../../assets/img/services/highquality-images.png',
          title: 'photography.contentCard-title1',
          description: 'photography.contentCard-description1',
          ctaTitle: '',
          ctaLink: ''
        },
        {
          img: '../../../../assets/img/services/floorplan.png',
          title: 'photography.contentCard-title2',
          description: 'photography.contentCard-description2',
          ctaTitle: '',
          ctaLink: ''
        }
      ],
      bottomRow: [
        {
          img: '../../../../assets/img/services/3d-tour-demo.png',
          title: 'photography.contentCard-title3',
          description: 'photography.contentCard-description3',
          ctaTitle: 'photography.contentCard-ctaTitle3',
          ctaLink: 'services/photography'
        },
        {
          img: '../../../../assets/img/services/3d-view.png',
          title: 'photography.contentCard-title4',
          description: 'photography.contentCard-description4',
          ctaTitle: '',
          ctaLink: ''
        }
      ]
    },
    section1Title: 'whyChooseService',
    whyChooseServiceDesc: 'photography.whyChoose.main-description',
    whyChooseService: [
      {
        icon: 'icon-newly-build',
        title: 'photography.whyChoose.title1',
        description: 'photography.whyChoose.description1'
      },
      {
        icon: 'icon-browse-property',
        title: 'photography.whyChoose.title2',
        description: 'photography.whyChoose.description2'
      },
      {
        icon: 'icon-make-an-offer',
        title: 'photography.whyChoose.title3',
        description: 'photography.whyChoose.description3'
      }
    ],
    section2Title: 'howWeWork',
    nextSteps: [
      'photography.nextSteps1',
      'photography.nextSteps2',
      'photography.nextSteps3'
    ],
    betterResults: [
      {
        percent: 95,
        label: 'photography.betterResults.label1'
      },
      {
        percent: 31,
        label: 'photography.betterResults.label2'
      },
      {
        percent: 71,
        label: 'photography.betterResults.label3'
      }
    ],
    section3Title: 'lookAtTheseServices.title',
    section3Description: 'lookAtTheseServices.description',
    services: availableServices.filter((service) => service.type !== UnikoServiceTypes.photography),
    requestServiceButtonLabel: 'photography.requestPhotography',
  }
